import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'slide', 'prevButton', 'nextButton'];

  connect() {
    this.currentIndex = 0;
    this.updateButtonStates();

    this.resizeHandler = this.handleResize.bind(this);
    window.addEventListener('resize', this.resizeHandler);

    this.handleResize();
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  handleResize() {
    if (window.innerWidth < 768) {
      this.enableSlider();
    } else {
      this.disableSlider();
    }
  }

  enableSlider() {
    this.containerTarget.classList.add('slider-enabled');
    this.updateButtonStates();
  }

  disableSlider() {
    this.containerTarget.classList.remove('slider-enabled');
    this.slideTargets.forEach(slide => {
      slide.style.transform = '';
    });
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToCurrentSlide();
    }
  }

  next() {
    if (this.currentIndex < this.slideTargets.length - 1) {
      this.currentIndex++;
      this.scrollToCurrentSlide();
    }
  }

  scrollToCurrentSlide() {
    const slideWidth = this.slideTargets[0].offsetWidth;
    const margin = 15;
    const scrollPosition = this.currentIndex * (slideWidth + margin);

    this.containerTarget.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });

    this.updateButtonStates();
  }

  updateButtonStates() {
    if (!this.hasPrevButtonTarget || !this.hasNextButtonTarget) return;

    this.updateButtonState({
      button: this.prevButtonTarget,
      isDisabled: this.currentIndex === 0,
      activeClass: ['opacity-100', 'cursor-pointer', 'bg-blue'],
      disabledClass: ['opacity-50', 'cursor-not-allowed', 'bg-gray-300'],
      svgFillActive: 'white',
      svgFillDisabled: '#383D45'
    });

    this.updateButtonState({
      button: this.nextButtonTarget,
      isDisabled: this.currentIndex >= this.slideTargets.length - 1,
      activeClass: ['opacity-100', 'cursor-pointer', 'bg-blue'],
      disabledClass: ['opacity-50', 'cursor-not-allowed', 'bg-gray-300'],
      svgFillActive: 'white',
      svgFillDisabled: '#383D45'
    });
  }

  updateButtonState({ button, isDisabled, activeClass, disabledClass, svgFillActive, svgFillDisabled }) {
    button.disabled = isDisabled;
    const addClasses = isDisabled ? disabledClass : activeClass;
    const removeClasses = isDisabled ? activeClass : disabledClass;
    button.classList.remove(...removeClasses);
    button.classList.add(...addClasses);

    const svg = button.querySelector('svg');
    if (svg) {
      svg.classList.toggle('text-white', !isDisabled);
      svg.classList.toggle('text-[#383D45]', isDisabled);

      const paths = svg.querySelectorAll('path');
      paths.forEach(path => {
        path.setAttribute('fill', isDisabled ? svgFillDisabled : svgFillActive);
      });
    }
  }
}
